module.exports = __webpack_public_path__ + "images/emoji/twisted_rightwards_arrows.f5c5f3678ec7bc9ccc62.png";